module.exports = __webpack_public_path__ + "img/05.2ac22fb8.webp";